import {
  enhancedMakeFetchAction,
  generateEndpoint
} from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

const apiCallGenerator = type => {
  const FETCH_DATA_LIST_API_ID = `DASHBOARD/FETCH_INVESTCORE_DISTRICTS_${type}`

  return enhancedMakeFetchAction(FETCH_DATA_LIST_API_ID, params => ({
    endpoint: generateEndpoint({
      host: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/districts`,
      params
    }),
    method: 'GET'
  }))
}

export default apiCallGenerator
